import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { PublicHoliday } from '../types/leave';

interface PublicHolidaysState {
  publicHolidays: PublicHoliday[];
}

const initialState: PublicHolidaysState = {
  publicHolidays: [],
};

const publicHolidaysSlice = createSlice({
  name: 'publicHolidays',
  initialState,
  reducers: {
    setPublicHolidays(state, action: PayloadAction<PublicHoliday[]>) {
      state.publicHolidays = action.payload;
    },
    addPublicHoliday(state, action: PayloadAction<PublicHoliday>) {
      state.publicHolidays = [...state.publicHolidays, action.payload].sort((a, b) => a.date.localeCompare(b.date));
    },
    updatePublicHoliday(state, action: PayloadAction<PublicHoliday>) {
      const idx = state.publicHolidays.findIndex((h) => h.date === action.payload.date);
      if (idx !== -1) state.publicHolidays[idx] = action.payload;
    },
    removePublicHoliday(state, action: PayloadAction<string>) {
      state.publicHolidays = state.publicHolidays.filter((h) => h.date !== action.payload);
    },
  },
});

export const { setPublicHolidays, addPublicHoliday, updatePublicHoliday, removePublicHoliday } = publicHolidaysSlice.actions;
export default publicHolidaysSlice.reducer;
